const common = {
  "nav.home": "الرئيسية",
  "nav.advantages": "المميزات",
  "nav.industries": "القطاعات",
  "nav.testimonials": "آراء العملاء",
  "nav.pricing": "الأسعار",
  "nav.faq": "الأسئلة الشائعة",
  "nav.contact": "اتصل بنا",
  "nav.dashboard": "لوحة التحكم",
  "nav.signIn": "تسجيل الدخول",
  "nav.logout": "تسجيل الخروج",
  "nav.toggleMenu": "فتح القائمة",
  "nav.profile": "الملف الشخصي",
  "nav.language": "اللغة",
  "nav.settings": "الإعدادات",
  "footer.tagline": "ابقَ في المقدمة",
  "footer.description": "احصل على تحديثات حول الميزات الجديدة ورؤى الصناعة ونصائح لعرض مزاياك بفعالية.",
  "footer.newsletter.placeholder": "اكتب رسالتك...",
  "footer.newsletter.subscribe": "واتساب",
  "footer.navigation": "التنقل",
  "footer.contact": "اتصل بنا",
  "footer.location": "الموقع",
  "footer.privacy": "الخصوصية",
  "footer.terms": "الشروط",
  "footer.copyright": "© 2026 Wyzon. جميع الحقوق محفوظة.",
  "footer.address": "123 طريق الابتكار، سان فرانسيسكو، كاليفورنيا 94102",
  "footer.phone": "+20 109 9289 280",
  "footer.email": "sales@debugin.com",
  "loading": "جاري التحميل...",
  "error.generic": "حدث خطأ ما",
  "error.network": "عذراً، حدث خطأ في الاتصال بالشبكة. يرجى التحقق من اتصالك بالإنترنت وإعادة المحاولة.",
  "error.failedToFetch": "فشل الاتصال بالخادم. يرجى التأكد من تشغيل خادم الـ Backend والمحاولة مرة أخرى.",
  "error.sessionNotFound": "جلسة العمل غير موجودة أو انتهت صلاحيتها. يرجى تسجيل الدخول مجدداً.",
  "error.failedToSend": "فشل إرسال الرسالة. يرجى التأكد من اتصال الرقم بالواتساب وصحة الرقم.",
  "error.rateLimit": "لقد تجاوزت عدد العمليات المسموح بها. يرجى المحاولة مرة أخرى بعد قليل.",
  "error.unauthorized": "غير مصرح لك بالقيام بهذا الإجراء. يرجى تسجيل الدخول مجدداً.",
  "error.token": "رمز الاتصال غير صالح أو انتهت صلاحيته. يرجى إعادة توليد رمز جديد.",
  "error.timeout": "انتهت مهلة الطلب. يرجى إعادة المحاولة.",
  "error.qr": "فشل إنشاء رمز الاستجابة السريعة (QR Code). يرجى التأكد من حالة اتصال الهاتف والشبكة.",
  "error.phone": "الرقم المدخل غير صحيح أو غير مسجل في الواتساب.",
  "error.invalidFormat": "صيغة الملف المدخل غير صالحة. يرجى التأكد من اختيار ملف متوافق.",
  "error.unexpected": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.",
  "button.tryAgain": "حاول مرة أخرى",
  "button.back": "رجوع",
  "button.submit": "إرسال",
  "button.cancel": "إلغاء",
  "button.close": "إغلاق",
  "language.en": "English",
  "language.ar": "العربية",
  "direction": "rtl",
  "plan.basic": "أساسية",
  "plan.pro": "برو",
  "plan.enterprise": "متقدمة",
  "brandName": "وايزون",

  // Countries
  "country.20": "مصر",
  "country.966": "السعودية",
  "country.971": "الإمارات",
  "country.965": "الكويت",
  "country.974": "قطر",
  "country.973": "البحرين",
  "country.968": "عُمان",
  "country.962": "الأردن",
  "country.961": "لبنان",
  "country.963": "سوريا",
  "country.964": "العراق",
  "country.967": "اليمن",
  "country.970": "فلسطين",
  "country.218": "ليبيا",
  "country.216": "تونس",
  "country.213": "الجزائر",
  "country.212": "المغرب",
  "country.249": "السودان",
  "country.252": "الصومال",
  "country.1": "أمريكا",
  "country.44": "بريطانيا",
  "country.33": "فرنسا",
  "country.49": "ألمانيا",
};

export default common;